import * as React from 'react';
import { SectionContainer } from '../../../SectionContainer';
import { ApiDisplay } from '../../../ApiDisplay';
import { CustomLink } from '../../../PageElements/CustomLink';
import { Text } from '../../../PageElements/Text';
import style from './RequestHeaders.scss';

export const RequestAuthorization = () => {
  return (
    <SectionContainer
      title="Authorization"
      className={style.requestHeaders}
      titleDataHook="request-authorization-title"
    >
      <ApiDisplay.RpcRest matchInitialType>
        <Text dataHook="request-authorization-text">
          This endpoint requires authentication. Check out{' '}
          <a
            href="https://bo.wix.com/wix-docs/rnd/platformization-guidelines/authenticating-as-api-client"
            target="_blank"
            rel="noopener noreferrer"
          >
            how to authenticate it
          </a>
          .
        </Text>
      </ApiDisplay.RpcRest>
      <ApiDisplay.REST matchInitialType>
        <Text dataHook="request-authorization-text">
          This endpoint requires an authorization header - pass the access token
          from the{' '}
          <CustomLink to="/getting-started/authentication">
            OAuth installation flow
          </CustomLink>
          .
        </Text>
      </ApiDisplay.REST>
    </SectionContainer>
  );
};
